import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import Reveal from '@/components/Reveal';
import SEO from '@/components/SEO';
import { SectionLabel } from '@/components/Button';

export default function Terms() {
  const { t } = useTranslation('terms');
  const sections = t('sections', { returnObjects: true });

  return (
    <Layout>
      <SEO title={t('seo.title')} description={t('seo.description')} />

      <section className="pt-32 md:pt-40 pb-12" data-testid="terms-page">
        <div className="max-w-content mx-auto px-6 lg:px-10 max-w-prose">
          <Reveal>
            <SectionLabel>{t('eyebrow')}</SectionLabel>
            <h1 className="mt-5 font-display text-4xl md:text-5xl font-semibold text-brand-primary leading-tight tracking-tight">
              {t('title')}
            </h1>
            <p className="mt-4 text-sm text-brand-muted">{t('lastUpdated')}</p>
          </Reveal>

          <div className="mt-12 prose-article">
            {sections.map((s, i) => (
              <div key={i}>
                <h2>{s.h}</h2>
                <p>{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
